export default ({ theme }) => `
display: flex;
flex-direction: column;
align-items: flex-start;
width: 100%;

  .input-fields-container {
    display: flex;
    flex-direction: column;
    width: calc(100% - 40px);
    padding: 5px 20px;
    background-color: #f5f5f5;
    border-radius: 5px;

    .input-label-with-info {
      display: flex;
      width: 100%;
      font-size: 14px;
      align-items: center;
      /* margin: 0px 0px -5px 0px !important; */
    }

    h4 {
      margin: 5px 0 0;
      font-size: 14px;
    }

  }

  .email-with-confirmation {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
  }

  .payment-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }

  .action-button-holder {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    .action-button-label {
      display: flex;
      font-size: 14px;
      margin-bottom: 5px;
      text-align: -webkit-center;
    }
  }

  .action-button-update-holder {
    display: flex;
    flex-direction: column;
    width: calc(100%-40px);
    justify-content: center;
    align-items: center;
    padding: 20px;
  }

  .title-and-limit{
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-start;
    min-height: 64px;
    width: 100%;

    .title {
      display: flex;
      justify-content: flex-start;
      text-align: center;
      margin: 10px 0px -5px;
      font-size: 14px;
      font-weight: bold;
      color: #495c63;
      width: 100%;
    }

    .limit {
      text-align: left;
      width: 100%;
      margin: 0px 0px 5px 0px;

      .dropdown-menu {
        /* font-size: 25px; */
        /* font-weight: bold; */
        /* border-color: red; */
      }

      .loading-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }

    }
  }


`;